import React from 'react';
import { useCurrentUser } from '@docavenue/components';
import { get } from 'lodash';
import { FieldProps } from 'formik';
import { useTranslation } from '@/src/i18n';
import Select from '../../molecules/Formik/Select';

/* Component props */
export interface ProfileSelectProps extends FieldProps {
  /**
   * The disabled status of the Select. If true, it will be impossible to interact with the select and it will turn grey.
   */
  disabled?: boolean;
}

const ProfileSelect: React.FC<ProfileSelectProps> = ({
  field,
  disabled = false,
  ...props
}) => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const patients = get(
    currentUser,
    'userPatientInformation.userPatientProfiles',
    [],
  );
  return (
    <Select
      field={field}
      defaultLabel={t('patient')}
      disabled={disabled}
      options={patients.map(({ id, firstName, lastName }) => ({
        id,
        name: `${firstName} ${lastName}`,
      }))}
      {...props}
    />
  );
};

export default ProfileSelect;
